<template>
<div>
    <!-- Modal Reidentificação do Usuário  -->
    <div class="modal fade reident_user" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Identificação do Usuário</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <button type="button" class="btn btn-primary mr-1 mb-1" v-for="(item, iix) in lista" :key="iix" @click="ident.login = item; $refs.campo_senha.focus();">
                            {{ item }}
                        </button>
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <input
                                ref="campo_login"
                                placeholder="Login..."
                                type="text"
                                v-model="ident.login"
                                required
                                :validate="validate"
                                autocomplete="off"
                                class="form form-control"
                                @keydown.enter="atualizar" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col col-12">
                            <input
                                ref="campo_senha"
                                placeholder="Senha..."
                                type="text"
                                id="password"
                                style="-webkit-text-security: disc;"
                                required
                                :validate="validate"
                                v-model="ident.senha"
                                autocomplete="off"
                                class="form form-control"
                                @keydown.enter="atualizar" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    <az-submit @click="atualizar()">Confirmar</az-submit>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            validate: false, 
            ident: { 
                login: "",
                senha: "", 
            }, 
            callback: null,
            final: null, 
            lista: [], 
        };
    },

    props: ['tipo'],

    components: { 
        AzSubmit, 
    }, 

    computed: { 
        modal_name: function () { 
            return 'reIdentUsuarioModal' + this.tipo; 
        }
    },

    methods: { 
        atualizar () { 
            if ( !this.ident.login ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Identificação",
                    detail: "Login não informado.",
                    life: 3000
                });
                return;
            }

            if ( !this.ident.senha ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Identificação",
                    detail: "Senha não informada.",
                    life: 3000
                });
                return;
            }

            this.callback(this.ident, () => { 
                this.fechar_modal();        
            });
        }, 

        abrir (callback, final = null) { 
            this.lista = this.$store.state.contexto['ident_logins']
                ? this.$store.state.contexto['ident_logins']
                : [];

            this.callback = callback;
            this.final = final; 

            this.validate = false; 

            this.ident.login = "";
            this.ident.senha = "";

            $('#' + this.modal_name).modal('show');

            setTimeout(() => { 
                this.$refs.campo_login.focus();
            }, 500);
        },

        fechar_modal () { 
            $('#' + this.modal_name).modal('hide');
        }
    }
}
</script>
